import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { HotToastService } from "@ngneat/hot-toast";
import { Observable } from "rxjs";
import { BaseService } from "../../_shared/services/base.service";
import { MenuItem } from "../models/menu-item";

@Injectable({
  providedIn: "root",
})
export class MenuService extends BaseService<MenuItem, MenuItem> {
  constructor(
    protected override http: HttpClient,
    @Inject("BASE_URL") protected override baseUrl: string,
    protected override toast: HotToastService | null = null
  ) {
    super(http, baseUrl, "menu", toast);
  }

  getMenuTemplate(): Observable<MenuItem[]> {
    return this.getAll("/top");
  }
}
